// extracted by mini-css-extract-plugin
export default {"container":"container--1e1gy","accept-call-large":"accept-call-large--xOpXV","accept-call-medium":"accept-call-medium--2D8T_","icon":"icon--3Un0h"};